module.exports = __webpack_public_path__ + "img/55.644a7407.png";